module.exports = __webpack_public_path__ + "img/inter.98cfef1a.png";